<template>
    <v-main>
        <v-container v-show="showParameters" fluid class="mt-3">
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="hehoCode" label="Homeowner booking ID" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="huisCode" hint="Search values beginning with..." label="Accommodation ID" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="6" class="mx-2">
                    <select_hust_codes :selected_husttypes="hustCodesSelected" field="hustCodesSelected" :isClearable="true" @updateData="updateData" :localStorageItem="localStorageItem"></select_hust_codes>
            </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoDatVanmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoDatVan" label="Booking date from" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoDatVan = $moment(hulpDate).format('DD-MM-YYYY'); hehoDatVanmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoDatTmmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoDatTm" label="Booking date until" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoDatTm = $moment(hulpDate).format('DD-MM-YYYY'); hehoDatTmmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoAnnDatVanmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoAnnDatVan" label="Cancellation date from" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoAnnDatVan = $moment(hulpDate).format('DD-MM-YYYY'); hehoAnnDatVanmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoAnnDatTmmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoAnnDatTm" label="Cancellation date until" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoAnnDatTm = $moment(hulpDate).format('DD-MM-YYYY'); hehoAnnDatTmmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoVanDatVanmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoVanDatVan" label="Arrival date from" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoVanDatVan = $moment(hulpDate).format('DD-MM-YYYY'); hehoVanDatVanmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoVanDatTmmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoVanDatTm" label="Arrival date until" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoVanDatTm = $moment(hulpDate).format('DD-MM-YYYY'); hehoVanDatTmmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoTmDatVanmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoTmDatVan" label="Departure date from" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoTmDatVan = $moment(hulpDate).format('DD-MM-YYYY'); hehoTmDatVanmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-menu v-model="hehoTmDatTmmenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="hehoTmDatTm" label="Departure date until" clearable v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="hulpDate" :first-day-of-week="1" @input="hehoTmDatTm = $moment(hulpDate).format('DD-MM-YYYY'); hehoTmDatTmmenu = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="klntEmail" label="Guest email" @keyup.enter="getHeho" autocomplete="new-guest-email"></v-text-field>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="klntNaam" hint="Use of wildcards (*<input>*) supported" label="Guest lastname" autocomplete="new-guest-name" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="1" class="mx-2">
                    <v-text-field v-model="klntTelefoon" hint="Use of wildcards (*<input>*) supported" label="Guest telephone" autocomplete="new-guest-telephone" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="1" class="mx-2">
                    <!-- <v-text-field v-model="klntCode" label="Guest ID" @keyup.enter="getHeho"></v-text-field> -->
                </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="eignEmail" hint="Search values beginning with..." label="Host email" autocomplete="new-host-email" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-text-field v-model="eignNaam" hint="Search values beginning with..." label="Host lastname" autocomplete="new-host-lastname" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="1" class="mx-2">
                    <v-text-field v-model="eignTelefoon" hint="Use of wildcards (*<input>*) supported" label="Host telephone" autocomplete="new-host-telephone" @keyup.enter="getHeho"></v-text-field>
                </v-col>
                <v-col cols="1" class="mx-2">
                    <v-text-field v-model="eignCode" label="Host ID" @keyup.enter="getHeho"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense no-gutters>
                <v-col cols="2" class="mx-2">
                    <v-checkbox v-model="hehoImported" label="Include imported bookings"></v-checkbox>
                </v-col>
                <v-col cols="2" class="mx-2">
                    <v-checkbox v-model="hehoTest" label="Include test bookings"></v-checkbox>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="1" span="2" style="display: flex; flex-direction: row; gap: 20px;" class="mx-2">
                    <v-btn class="warning ma-0" small @click="parametersShow()" v-if="showClearButton"><v-icon left>mdi-refresh</v-icon>Clear</v-btn>
                    <v-btn class="primary ma-0" small @click="getHeho()"><v-icon left>mdi-magnify</v-icon>Search</v-btn>
                    <v-btn v-if="filteredItems.length>0" class="primary ma-0" small @click="showParameters=false"><v-icon left>mdi-eye-off-outline</v-icon>Hide parameters</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid :class="{'smallfont': $vuetify.breakpoint.lgAndDown}">
            <v-btn v-show="!showParameters" class="primary ma-0" small @click="parametersShow()"><v-icon left>mdi-eye-outline</v-icon>Show parameters</v-btn>
            <div v-if="results">
            <v-card flat class="px-2 mt-1">
                <div style="display: flex; align-items: center; gap: 20px; margin-right: 40px;">
                    <v-text-field v-model="search" label="Search in results" single-line hide-details prepend-icon="mdi-magnify"></v-text-field> 
                </div>
                <v-data-table :items="filteredItems" :headers="headers" hide-default-footer :search="search"
                    :items-per-page="getRowsPerPage()" :page.sync="page" no-data-text="No bookings to display"
                    loading-text="Loading data...please wait" :loading="loading">
                    <template v-slot:item="props">
                        <tr>
                            <td @click="$router.open('/heho/onHeho/' + props.item.heho_encrid + '/' + props.item.huis_encrid)" class="font-row"><a>{{ props.item.heho_code }} </a></td>
                            <td class="font-row"><v-chip small :color=props.item.hust_kleur><span class="chiptext">{{ props.item.hust_code }}</span></v-chip></td>
                            <td class="font-row">{{ props.item.heho_type }}</td>
                            <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="font-row"><a> {{ props.item.huis_code }} </a></td>
                            <td class="font-row">{{ $moment(props.item.heho_dt).format("DD-MMM-YYYY HH:mm") }}</td>
                            <td class="font-row">{{ props.item.heho_pers }}</td>
                            <td class="font-row">{{ props.item.heho_klant_naam }}</td>
                            <!-- <td class="font-row">{{ $moment(props.item.heho_van_dat).format("DD-MMM-YYYY ddd") }}</td>
                            <td class="font-row">{{ $moment(props.item.heho_tm_dat).format("DD-MMM-YYYY ddd") }}</td> -->
                            <td class="font-row">{{ props.item.heho_van_dat }}</td>
                            <td class="font-row">{{ props.item.heho_tm_dat }}</td>
                            <td class="font-row"></td>
                        </tr>
                    </template>
                </v-data-table>
                <div v-if="!loading&&items.length>0" style="display: flex; align-items: center; justify-content :end; margin-top: 10px; font-size: small; color:grey;">
                    <v-btn icon @click="goToFirstPage" :disabled="page === 1"><v-icon>mdi-chevron-double-left</v-icon></v-btn>
                    <v-btn icon @click="goToPreviousPage" :disabled="page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                    <div style="display: flex; justify-content: center; align-items: center; margin-left: 15px; margin-right: 15px; min-width: 80px;">Page {{ page }} of {{ lastPage }}</div>
                        <v-btn icon @click="goToNextPage" :disabled="page === lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
                        <v-btn icon @click="goToLastPage" :disabled="page === lastPage"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
                    <div style="margin-left: 15px; min-width: 150px;">Record {{ startRecord }}-{{ eindRecord }} of {{ filteredItems.length }} </div>
                </div>
            </v-card>
        </div>
        </v-container>
        <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main" />
        <standard_dialog ref="standard_dialog" @standard_dialog_close="parametersShow(false)" />
    </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import select_hust_codes from "@/components/ui/selectors/select_hust_codes.vue"
    import standard_dialog from '@/components/ui/standard_dialog.vue';

    export default {
        components: {
            navBar,
            select_hust_codes,
            standard_dialog,
        },
        data() {
            return {
                localStorageItem: 'search.heho.hustcodes',

                results: false,

                // params: {},
                showParameters: true,
                items: [],
                hehoCode: '',
                huisCode: '',
                HehoDatum: '',
                hulpDate: '',
                hehoDatVan: '',
                hehoDatTm: '',
                search: '',
                loading: false,

                hustCodesSelected: [],
                hustCodes: [],
                hehoDatVanmenu: false,
                hehoDatTmmenu: false,
                hehoAnnDatVan: '',
                hehoAnnDatTm: '',
                hehoAnnDatVanmenu: false,
                hehoAnnDatTmmenu: false,
                hehoVanDatVan: '',
                hehoVanDatTm: '',
                hehoVanDatVanmenu: false,
                hehoVanDatTmmenu: false,
                hehoTmDatVan: '',
                hehoTmDatTm: '',
                hehoTmDatVanmenu: false,
                hehoTmDatTmmenu: false,

                hehoTest: false,
                hehoImported: true,

                klntEmail: '',
                hehoOtaCode: '',
                klntCode: '',
                klntNaam: '',
                klntTelefoon: '',
                klntOpenstaand: false,
                eignNaam: '',
                eignCode: '',
                eignEmail: '',
                eignTelefoon: '',
                eignOpenstaand: false,
                page: 1,
                showClearButton: false,

                // headers: [
                //     { text: 'Id', value: 'huov_code' },
                //     { text: 'Status', value: 'hust_code' },
                //     { text: 'Accommodation', value: 'huis_code' },
                //     { text: 'Booking', value: 'huov_dt' },
                //     { text: 'Persons', value: 'huov_pers' },
                //     { text: 'Arrival', value: 'huov_van_dat' },
                //     { text: 'Departure', value: 'huov_tm_dat' },
                //     { text: 'Guest', value: 'klnt_naam' },
                //     { text: 'Sales partner', value: 'inpt_naam' },
                //     { text: 'Guest Inv', value: 'huov_klnt_factuur_dec', align: "end" },
                //     { text: 'Guest Pay', value: 'huov_klnt_betaald_dec', align: "end" },
                //     { text: 'Host Inv', value: 'huov_eign_factuur_dec', align: "end" },
                //     { text: 'Host Pay', value: 'huov_eign_betaald_dec', align: "end" },
                //     { text: '', sortable: false, width: '7%' }
                // ]
                headers: [
                    { text: 'Id', value: 'heho_code' },
                    { text: 'Status', value: 'hust_code' },
                    { text: 'Type', value: 'heho_type' },
                    { text: 'Accommodation', value: 'huis_code' },
                    { text: 'Booking date', value: 'heho_dt' },
                    { text: 'Persons', value: 'heho_pers' },
                    { text: 'Customer name', value: 'heho_klnt_naam' },
                    { text: 'Arrival date', value: 'heho_van_dat' },
                    { text: 'Departure date', value: 'heho_tm_dat' },
                    { text: '', sortable: false, width: '7%' }
                ]
            }
        },
        computed: {
            lastPage() {
                return Math.ceil(this.filteredItems.length / this.getRowsPerPage());
            },
            startRecord() {
                return (this.page - 1) * this.getRowsPerPage() + 1;
            },
            eindRecord() {
                return Math.min(this.page * this.getRowsPerPage(), this.filteredItems.length);
            },
            filteredItems() {
                const lowerCaseSearch = this.search.toLowerCase();
                this.goToFirstPage();
                return this.items.filter(item => {
                    return !this.search || 
                        item.heho_code.toLowerCase().includes(lowerCaseSearch) ||
                        item.huis_code.toLowerCase().includes(lowerCaseSearch) ||
                        item.heho_type.toLowerCase().includes(lowerCaseSearch) ||
                        item.klnt_naam.toLowerCase().includes(lowerCaseSearch) ||
                        item.heho_dt.toLowerCase().includes(lowerCaseSearch) ||
                        item.heho_pers.toString().includes(lowerCaseSearch) ||
                        item.heho_van_dat.toLowerCase().includes(lowerCaseSearch) ||
                        item.heho_tm_dat.toLowerCase().includes(lowerCaseSearch);
                });
            },  
        },
        mounted() {
            this.parametersShow();
        },
        methods: {
            // getSearchHehoParam() {
            //     this.$axios.post("ares/json/ares/heho/getSearchHehoParam.p", {
            //         header: {
            //             token: this.$session.get("ARES"),
            //             clientSessionId: this.$session.id(),
            //             request: "getSearchHehoParam"
            //         },
            //         getSearchHehoParam: {}
            //     }).then(res => {
            //         if (res.data.error) {
            //             console.log(res.data.error);
            //         } else {
            //             this.parametersShow()
            //             this.param = res.data.getSearchHehoParam;
            //             this.inpt_codeKeuzes = res.data.getSearchHehoParam.inpt_codeKeuzes
            //         }
            //     });
            // },
            goToFirstPage() {
                this.page = 1;
            },
            goToLastPage() {
                this.page = this.lastPage;
            },
            goToPreviousPage() {
                if (this.page > 1) {
                    this.page--;
                }
            },
            goToNextPage() {
                if (this.page < this.lastPage) {
                    this.page++;
                }
            },
            getRowsPerPage() {
                const rowHeight = 48; // Approximate height of each row in pixels
                const headerHeight = 56; // Approximate height of the header in pixels
                const availableHeight = window.innerHeight - headerHeight - 200; // 200 is an approximate value for the height of the other elements on the page

                return Math.floor(availableHeight / rowHeight);
            },
            updateData(data){
                this[data.field] = data.value;
            },
            parametersShow(clearParams=true) {
                if(clearParams) {
                    this.hehoCode = '';
                    this.huisCode = '';

                    this.hehoDatVan = '';
                    this.hehoDatTm = '';
                    this.hehoAnnDatVan = '';
                    this.hehoAnnDatTm = '';
                    this.hehoVanDatVan = '';
                    this.hehoVanDatTm = '';
                    this.hehoTmDatVan = '';
                    this.hehoTmDatTm = '';
                    this.klntCode = '';
                    this.klntEmail = '';
                    this.klntNaam = '';
                    this.klntTelefoon = '';
                    this.eignCode = '';
                    this.eignEmail = '';
                    this.eignNaam = '';
                    this.eignTelefoon = '';
                    this.hehoOtaCode = '';
                }
                this.showParameters = true;
                this.items = [];
                this.results = false;
                this.search = '';
            },
            getHeho() {
                this.results = true;
                this.showParameters = false;
                this.loading=true;
                this.items = [];
                this.$axios.post("ares/json/ares/heho/searchHeho2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchHeho"
                    },
                    searchHeho: {
                        heho_code: this.hehoCode,
                        huis_code: this.huisCode,
                        heho_datum_van: this.hehoDatVan,
                        heho_datum_tm: this.hehoDatTm,
                        heho_ann_datum_van: this.hehoAnnDatVan,
                        heho_ann_datum_tm: this.hehoAnnDatTm,
                        heho_van_dat_van: this.hehoVanDatVan,
                        heho_van_dat_tm: this.hehoVanDatTm,
                        heho_tm_dat_van: this.hehoTmDatVan,
                        heho_tm_dat_tm: this.hehoTmDatTm,
                        
                        //klnt_code: this.klntCode,
                        klnt_email: this.klntEmail,
                        klnt_naam: this.klntNaam,
                        klnt_telefoon: this.klntTelefoon,
                        
                        eign_naam: this.eignNaam,
                        eign_code: this.eignCode,
                        eign_email: this.eignEmail,
                        eign_telefoon: this.eignTelefoon,
                        
                        hehoTest: this.hehoTest,
                        hehoImported: this.hehoImported,

                        hust_codes: this.hustCodesSelected,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$refs.standard_dialog.setWidth(450);
                        this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-3 pt-6");
                        this.$refs.standard_dialog.open('warning', 'Warning', res.data.error.message);
                        this.showClearButton = true
                        this.loading = false;
                    } else {
                        this.items = res.data.searchHeho;
                        this.loading = false;               
                        this.showClearButton = false
                        localStorage.setItem(this.localStorageItem, this.hustCodesSelected);            
                    }
                });
            }
        }
    };
</script> 

<style scoped>
    .grid-item-error {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid red;
        color: red;
        cursor: default;
    }

    .grid-item-warning {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid orange;
        color: orange;
        cursor: default;
    }

    .grid-item-pending {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid blue;
        color: blue;
        cursor: default;
    }

    .grid-item-change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid #FF8800;
        color: #FF8800;
        cursor: default;
    }

    .grid-item-ok {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid green;
        color: green;
        cursor: default;
    }

    .format-amount {
        text-align: end;
    }
    .font-row{
        font-size: smaller !important;
    }
    .flex{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .last-item {
        margin-left: auto;
    }
    .chiptext {
       color: black !important;
    }
</style>
